import React from "react";
import PropTypes from "prop-types";
import { graphql } from "gatsby";

import LinkWrapper from "@/components/linkWrapper";
import MediaWrapper from "@/components/mediaWrapper";
import MarkdownWrapper from "@/components/markdownWrapper";

export const query = graphql`
  fragment Page404GridWithImageData on StrapiComponent404GridWithImage {
    companyLogo {
      ...StrapiSharedLink
    }
    topic
    title
    description
    image {
      ...StrapiMediaSubquery
    }
  }
`;

function GridWithImage({ data }) {
  if (!data) {
    return <template />;
  }

  return (
    <div className="flex items-center justify-center bg-background-white">
      <div className="grid max-w-6xl grid-cols-1 px-4 py-16 lg:grid-cols-2 lg:px-8 lg:py-20">
        <div className="flex w-full flex-col">
          <div className="flex-shrink-0 pt-10 sm:pt-16">
            {(data.companyLogo?.overwriteIcon ||
              data.companyLogo?.link?.icon) && (
              <LinkWrapper
                to={data.companyLogo?.link?.url || "/"}
                className="inline-flex"
              >
                {(data.companyLogo?.overwriteTitle ||
                  data.companyLogo?.link?.title) && (
                  <span className="sr-only">
                    {data.companyLogo.overwriteTitle ||
                      data.companyLogo.link.title}
                  </span>
                )}
                <MediaWrapper
                  media={
                    data.companyLogo.overwriteIcon || data.companyLogo.link.icon
                  }
                  divClassName="h-12 w-auto"
                  objectFit="contain"
                />
              </LinkWrapper>
            )}
          </div>
          <div className="my-auto flex-shrink-0 py-16 sm:py-32">
            {data.topic && (
              <MarkdownWrapper
                text={data.topic}
                markdownClassName="text-4xl sm:text-5xl text-text-highlight font-semibold tracking-wide uppercase"
              />
            )}
            {data.title && (
              <h1 className="mt-2 text-4xl font-extrabold tracking-tight text-text-primary sm:text-5xl">
                <MarkdownWrapper text={data.title} />
              </h1>
            )}
            {data.description && (
              <MarkdownWrapper
                text={data.description}
                markdownClassName="mt-2 text-base text-text-secondary"
              />
            )}
          </div>
        </div>
        <div className="w-full p-8">
          {data.image ? (
            <MediaWrapper
              media={data.image}
              divClassName="w-full h-full"
              objectFit="contain"
            />
          ) : (
            <svg
              version="1.1"
              id="Layer_1"
              xmlns="http://www.w3.org/2000/svg"
              x="0px"
              y="0px"
              viewBox="0 0 512 512"
              className="ml-auto"
            >
              <g>
                <g>
                  <path
                    d="M262.468,0H251.85C153.818,0,72.902,79.089,72.902,177.126v324.407c0,4.026,2.884,7.684,6.511,9.431
                    c3.617,1.747,8.214,1.257,11.354-1.257l45.149-36.007l35.303,35.23c4.087,4.087,10.744,4.087,14.831,0l34.471-34.454
                    l34.462,34.454c4.087,4.087,10.713,4.087,14.8,0l34.456-34.454l34.454,34.454c4.087,4.087,10.709,4.087,14.796,0l34.454-34.454
                    l34.453,34.454c2.003,2.003,4.675,3.065,7.398,3.065c1.349,0,2.129-0.255,3.427-0.797c3.908-1.614,5.878-5.436,5.878-9.666
                    V177.126C439.098,79.089,360.499,0,262.468,0z M418.173,476.275l-23.411-23.991c-4.087-4.087-10.418-4.087-14.505,0
                    l-34.309,34.454l-34.381-34.454c-2.044-2.043-4.685-3.065-7.362-3.065c-2.677,0-5.336,1.022-7.38,3.065l-34.444,34.454
                    l-34.449-34.454c-4.087-4.087-10.705-4.087-14.792,0l-34.454,34.454l-34.452-34.454c-3.77-3.77-10.357-4.107-14.51-0.777
                    l-35.897,28.252V177.126c0-86.502,71.527-156.201,158.023-156.201h10.617c86.495,0,155.705,69.699,155.705,156.201V476.275z"
                  />
                </g>
              </g>
              <g>
                <g>
                  <path
                    d="M194.383,156.262c-14.423,0-26.157,11.73-26.157,26.157c0,14.427,11.733,26.157,26.157,26.157
                    c14.421,0,26.156-11.73,26.156-26.157C220.539,167.992,208.804,156.262,194.383,156.262z M194.383,187.65
                    c-2.888,0-5.231-2.35-5.231-5.231c0-2.881,2.344-5.231,5.231-5.231c2.885,0,5.231,2.35,5.231,5.231
                    C199.615,185.3,197.268,187.65,194.383,187.65z"
                  />
                </g>
              </g>
              <g>
                <g>
                  <path
                    d="M319.935,156.262c-14.422,0-26.157,11.73-26.157,26.157c0,14.427,11.735,26.157,26.157,26.157
                    c14.422,0,26.157-11.73,26.157-26.157C346.092,167.992,334.357,156.262,319.935,156.262z M319.935,187.65
                    c-2.886,0-5.231-2.35-5.231-5.231c0-2.881,2.345-5.231,5.231-5.231s5.231,2.35,5.231,5.231
                    C325.166,185.3,322.821,187.65,319.935,187.65z"
                  />
                </g>
              </g>
            </svg>
          )}
        </div>
      </div>
    </div>
  );
}

GridWithImage.propTypes = {
  data: PropTypes.object,
};

export default GridWithImage;
